type NewBoxIconProps = {
  color?: string;
  width?: string;
  height?: string;
}

export const NewBoxIcon = ({
  color = '#363BC4', width = '12', height = '13', ...props
}: NewBoxIconProps): JSX.Element => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 12 13"
  >
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M10.958 3.745 6 6.5m0 0L1.042 3.745M6 6.5v5.542m5.25-3.175V4.133c0-.2 0-.3-.03-.39a.6.6 0 0 0-.124-.212c-.064-.069-.151-.117-.326-.214L6.453.918C6.288.827 6.205.781 6.118.763a.6.6 0 0 0-.236 0c-.087.018-.17.064-.335.155L1.23 3.317c-.175.097-.262.145-.326.214a.6.6 0 0 0-.125.213c-.029.089-.029.189-.029.389v4.734c0 .2 0 .3.03.39a.6.6 0 0 0 .124.212c.064.069.151.117.326.214l4.317 2.399c.165.091.248.137.335.155a.6.6 0 0 0 .236 0c.087-.018.17-.064.335-.155l4.317-2.399c.175-.097.262-.145.326-.214a.6.6 0 0 0 .125-.213c.029-.089.029-.189.029-.389"
    />
  </svg>
);
